import {Container} from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

const journey = {
    academic: [{
        name: "B Tech. in Computer Engineering with specialization in Artificial Intelligence",
        clg: "Marwadi University, Rajkot",
        year: "2018 - 2022",
        score: "6.83"
    }],
    professionalStory: [{
        name: "Lead Support Intern",
        com: "Speed-O-Bits ISP Company, Rajkot",
        year: "June 2020 - Dec 2020",
    }, {
        name: "Software Engineer Trainee",
        com: "Weboccult Technologies Pvt. Ltd., Ahmedabad",
        year: "Jan 2022 - Aug 2022",
    }, {
        name: "Jr. Software Engineer",
        com: "Weboccult Technologies Pvt. Ltd., Ahmedabad",
        year: "Sept 2022 - Sept 2023",
    }, {
        name: "Software Engineer",
        com: "Weboccult Technologies Pvt. Ltd., Ahmedabad",
        year: "Sept 2023 - Present",
    }]
};

export function Timeline() {
    return (
        <Container id="timeline">
            <div className="timeline">
                {/* Academic Timeline */}
                <ScrollAnimation animateIn="fadeInLeft">
                    <h2>Academic Journey</h2>
                    {journey.academic.map((degree, index) => (
                        <div key={index} className="timeline-item">
                            <div className="timeline-dot"></div>
                            <div className="timeline-content">
                                <p className="title">{degree.name}</p>
                                <p className="institution">{degree.clg}</p>
                                <p className="year">{degree.year}</p>
                                <p className="score">{degree.score} CGPA</p>
                            </div>
                        </div>
                    ))}
                </ScrollAnimation>

                {/* Professional Story */}
                <ScrollAnimation animateIn="fadeInRight">
                    <h2>Professional Journey</h2>
                    {journey.professionalStory.map((position, index) => (
                        <div key={index} className="timeline-item">
                            {/*<div className="timeline-dot"></div>*/}
                            <div className="timeline-content">
                                <p className="title">{position.name}</p>
                                <p className="company">{position.com}</p>
                                <p className="year">{position.year}</p>
                            </div>
                        </div>
                    ))}
                </ScrollAnimation>
            </div>
        </Container>
    );
}
